import { Text } from "metabase/ui";

export const Separator = () => (
  <Text c="text-secondary" flex="0 0 auto" fw="bold">
    /
  </Text>
);
